import React, { Component } from "react";
import ContactForm from "./ContactForm";

import about from "../../assets/images/about/contact.png";

import { withTranslation } from 'react-i18next';

class ContactTwo extends Component {
  render() {

    const { t } = this.props;

    return (
      <div className="contact-form--1">
        <div className="container">
          <div className="row row--35 align-items-start">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="section-title text-left mb--30">
                <h2 className="title">{t('Dejanos mensaje')}</h2>
                <p className="description"
                  dangerouslySetInnerHTML={{ __html: t('text_form') }} />
              </div>
              <div className="form-wrapper">
                <ContactForm />
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="thumbnail mb_md--30 mb_sm--30">
                <img src={about} alt="trydo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ContactTwo);
